import { type AxiosInstance, type AxiosError, HttpStatusCode } from "axios";
import useSWR, { type KeyedMutator } from "swr";
import type { GetRegistryChangeAlertSummaryAPIResponse } from "@/features/registryChangeAlert/types";
import { SendToTrackingService } from "@/api/handlers/errors";

export const REGISTRY_CHANGE_ALERT_SUMMARY_ENDPOINT =
  "/registry-change-alerts/summary";

interface IResponse {
  data: GetRegistryChangeAlertSummaryAPIResponse | undefined;
  isLoading: boolean;
  mutate: KeyedMutator<GetRegistryChangeAlertSummaryAPIResponse>;
  error: AxiosError | undefined;
}

/**
 * 変動アラートの要約（件数・未読数・新しい順の数件）を取得する。
 * enabled が false の間は発火しない（機能フラグ無効時にリクエストしないため）。
 * @param {AxiosInstance} apiClient JWT 認証付き apiClient
 * @param {boolean} enabled 取得するか
 * @returns {IResponse}
 */
export const GetRegistryChangeAlertSummaryAPI = (
  apiClient: AxiosInstance,
  enabled: boolean
): IResponse => {
  const { data, isLoading, mutate, error } = useSWR<
    GetRegistryChangeAlertSummaryAPIResponse,
    AxiosError
  >(
    enabled ? REGISTRY_CHANGE_ALERT_SUMMARY_ENDPOINT : null,
    async (url: string) => {
      const response =
        await apiClient.get<GetRegistryChangeAlertSummaryAPIResponse>(url);
      return response.data;
    },
    { revalidateOnFocus: false }
  );

  if (
    error &&
    (error.response?.status ?? HttpStatusCode.InternalServerError) >=
      HttpStatusCode.InternalServerError
  ) {
    SendToTrackingService(error);
  }

  return { data, isLoading, mutate, error };
};
